import { useEffect, useState } from 'react';
import { getConnectionOnline, subscribeConnection } from '../lib/connection';

// Persistent, app-wide banner shown when the backend is unreachable at the network level
// (a dead backend currently masquerades as silent save failures — the 2026-06-10 dead-stack
// incident). Clears automatically on the next successful request. Fed by api.ts via the
// connection store; not wired per-component.
export default function ConnectionBanner() {
  const [online, setOnline] = useState(getConnectionOnline());
  useEffect(() => subscribeConnection(setOnline), []);

  if (online) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        background: '#b91c1c', color: '#fff', textAlign: 'center',
        padding: '8px 16px', fontSize: 13, fontWeight: 700,
        fontFamily: 'system-ui, sans-serif', boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
      }}
    >
      ⚠ Backend unreachable — check your connection. Changes can’t be saved until it reconnects.
    </div>
  );
}
